'use strict';

var Player = require('./lib/player');
var Carousel = require('./lib/carousel');

// Constructor
var MultimediaHero = function() {
  var self = this;

  self.init = function() {
    new Player().init();
    new Carousel().init();
  }
};

module.exports = MultimediaHero;
